//引入api接口
import { fun_PostAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      /*************************项目信息***************************/
      tenderMakeId: null, // 标书文件制作表主键
      sectionId: null, // 标段编号
      /*************************标段信息***************************/
      // 列表loading状态
      loading: false,
      form: {
        projectName: null,
        tenderName: null,
        tenderAgentOrgan: null,
        tenderMakeId: null,
        processState: null,
        decodeState: null,
        bidEndDate: null,
        reviewStartDate: null
      },
      // 表单配置
      formConfigList: [
        {
          label: "项目名称：",
          value: "projectName",
          type: "slot",
          slotName: "projectName"
        },
        {
          label: "招标人：",
          value: "tenderName",
          type: "slot",
          slotName: "tenderName"
        },
        {
          label: "招标代理：",
          value: "tenderAgentOrgan",
          type: "slot",
          slotName: "tenderAgentOrgan"
        }
      ],
      tableColumns: [
        {
          label: "投标单位名称",
          prop: "corpName"
        },
        {
          label: "拒收标志",
          slotName: "isScrap"
        },
        {
          label: "解密标志",
          slotName: "isDecode"
        },
        {
          label: "清单传输标志",
          slotName: "listTransferFlag"
        },
        {
          label: "执行插入数据",
          slotName: "insertData"
        },
        {
          label: "执行存储过程",
          slotName: "procedure"
        },
        {
          label: "执行插入数据和存储过程",
          slotName: "insertDataAndProcedure"
        }
      ],
      total: null,
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      tableData: [],
      // 专家编号
      expertId: null,
      // 流程节点编号
      processNodeId: null,
      // 任务编号
      taskId: null
    };
  },

  mounted() {
    // 资格预审标志
    this.prequalificationType = this.$route.query.prequalificationType;
    // 标书文件制作表主键
    this.tenderMakeId = this.$route.query.tenderMakeId;
    // 标书文件制作表主键
    this.sectionId = this.$route.query.sectionId;
    // 获取项目信息
    this.fun_GetProjectInfo();
    // 获取任务信息
    this.fun_GetCorpList();
  },
  // 自定义事件
  methods: {
    /***********************************项目信息**************************************/
    /**
     * 获取项目信息
     */
    fun_GetProjectInfo() {
      // 请求
      fun_PostAction("/tenderSection/getProjectInfo", {
        tenderMakeId: this.tenderMakeId,
        prequalificationType: this.prequalificationType
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 项目名称
          this.form.projectName = data.projectName;
          // 招标人
          this.form.tenderName = data.tenderName;
          // 招标代理机构
          this.form.tenderAgentOrgan = data.tenderAgentOrgan;
          // 项目编号
          this.form.tenderMakeId = this.tenderMakeId;
          // 流程状态
          this.form.processState = data.processState;
          // 解密状态
          this.form.decodeState = data.decodeState;
          // 开标时间
          this.form.bidEndDate = data.bidEndDate;
          // 评标开始时间
          this.form.reviewStartDate = data.reviewStartDate;
        } else {
          // 请求失败的场景
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    },

    /***********************************标段信息**************************************/
    /**
     * 获取投标单位信息
     */
    fun_GetCorpList() {
      // 打开loading
      this.loading = true;
      // 执行获取列表接口
      fun_PostAction("inventoryManager/getCorpList", {
        sectionId: this.sectionId,
        prequalificationType: this.prequalificationType,
        ...this.reqPageData
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 将请求到的table数据渲染到table
          this.tableData = data.records;
          this.total = data.total;
        } else {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 数据字典改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetCorpList();
    },
    /**
     * 数据字典改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetCorpList();
    },
    fun_InsertData(e, type) {
      try {
        // 打开loading
        // this.loading = true;
        // 执行获取列表接口
        fun_PostAction(
          "inventoryManager/insertSingleData",
          {
            corpId: e.corpId,
            sectionId: e.sectionId,
            filePath: e.tbQdXmlPath,
            type: type
          },
          150000
        ).then(res => {
          // 解构res.data
          const { result, msg } = res.data;
          // 解析后台返回的结果集，判断是否成功
          if (result) {
            // 成功的场景
            this.$message.success(msg);
          } else {
            // 请求失败的场景
            // 请求失败，弹出失败msg的消息提示
            this.$message.error(msg);
          }
          // 关闭loading
          // this.loading = false;
        });
      } catch {
        // 关闭loading
        // this.loading = false;
      }
    },
    /**
     * 返回
     * @author 滕威
     */
    fun_Back() {
      this.$router.back();
    }
  }
};
